import { lazy } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import PrivateLayout from '../layouts/PrivateLayout'
import { SuspensedView } from '../helpers/components/SuspendedView'

const PrivateRoutes = () => {
    const ProfilePage = lazy(() => import('../pages/profile'))
    const Dashboard = lazy(() => import('../pages/dashboard'))
    const Configurations = lazy(() => import('../pages/configurations'))
    const Patients = lazy(() => import('../pages/patients'))
    const Pharama = lazy(() => import('../pages/pharma'))

    return (
        <Routes>
            <Route element={<PrivateLayout />}>
                <Route path='auth/*' element={<Navigate to='/dashboard' />} />

                <Route
                    path='profile/*'
                    element={
                        <SuspensedView>
                            <ProfilePage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='dashboard'
                    element={
                        <SuspensedView>
                            <Dashboard />
                        </SuspensedView>
                    }
                />
                <Route
                    path='configurations/*'
                    element={
                        <SuspensedView>
                            <Configurations />
                        </SuspensedView>
                    }
                />
                <Route
                    path='patients/*'
                    element={
                        <SuspensedView>
                            <Patients />
                        </SuspensedView>
                    }
                />
                <Route
                    path='pharma/*'
                    element={
                        <SuspensedView>
                            <Pharama />
                        </SuspensedView>
                    }
                />
            </Route>
        </Routes>
    )
}

export default PrivateRoutes
